//!#system	

<template>
	<div>
		<div class="detail-header-tags">
			<v-combobox
				v-if="canAddTags"
				v-model="chips"
				:items="items"
				chips
				:search-input.sync="search"
				label="Tag this as..."
				multiple
				solo
				flat
				:loading="isLoading"
				dense
				@change="changed"
			>
				<template v-slot:selection="{ attrs, item, select, selected }">
					<v-chip
						v-bind="attrs"
						:input-value="selected"
						close
						small
						@click="select"
						@click:close="remove(item)"
					>
						<strong>{{ item }}</strong>&nbsp;
					</v-chip>
				</template>
				<template v-slot:no-data>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title>
							No tags match <strong>{{ search }}</strong>. Your <em>Admin</em> users can create new tags that add new functionality.
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>
			</v-combobox>
			<div v-else class="mb-1">
				<v-chip
					class="mr-2"
					small
					v-for="chip in chips"
					:key="chip"
					close
					@click:close="remove(chip)"
				>
					<strong>{{chip}}</strong>
				</v-chip>
			</div>
			<div v-if="errorState" class="tagErrorMessage">
				<v-alert type="error">{{ errorMessage }}</v-alert>
			</div>
		</div>
	</div>
</template>

<script>
import apiService from '@/apiService';
import series from 'to-series';
export default {
	props: {
		tagged: {
			type: Array
		},
		namespace: {
			type: String
		}, 
		title: {
			type: String
		}, 
		name: {
			type: String
		}, 
		pluralName: {
			type: String
		}, 
		id: {
			type: [String, Number]
		}
	},
	data () {
		return {
			canAddTags: true,
			chips: [], // current tags on the item
			items: [], // tags that can be added
			availableTags: [], // tags loaded via the API (array of objects)
			search: '',
			errorState: false,
			errorMessage: '',
			isLoading: false,
			shadowTags: []
		}
	},

	methods: {
		remove(item) {
			this.removeTag(item, (err) => {
				if (err) {
					// already alerted the user in `removeTag`
				} else {
					this.chips.splice(this.chips.indexOf(item), 1)
					this.chips = [...this.chips];
				}
			});
		},
		addTag(item, done) {
			this.isLoading = true;
			apiService.tag({ 
				namespace: this.namespace,
				pluralName: this.pluralName,
				id: this.id,
				body: { tag: item }
			}, (err) => {
				if (err) {
					this.errorState = true;
					this.errorMessage = err;
				}
				this.isLoading = false;
				this.$emit('update');
				if (done) {
					done(err);
				}
			});
		},
		removeTag(item, done) {
			this.isLoading = true;
			apiService.untag({ 
				namespace: this.namespace,
				pluralName: this.pluralName,
				id: this.id,
				body: { tag: item }
			}, (err, tags, meta) => {
				if (meta.errCodes.includes('C053')) {
					// ignore
				} else if (err) {
					this.errorState = true;
					this.errorMessage = err;
				}
				this.isLoading = false;
				this.$emit('update');
				if (done) {
					done(err);
				}
			});
		},
		getAvailableTags() {
			apiService.availableTags({ 
				namespace: this.namespace,
				pluralName: this.pluralName
			}, (err, tags) => {
				if (err && err.message && err.message.includes('No permission to add tags')) {
					this.items = this.tagged;
					this.canAddTags = false;
				} else if (err) {
					this.errorState = true;
					this.errorMessage = err;
				} else {
					this.availableTags = tags;
					this.items = this.availableTags.map(obj => obj.tag);
				}
			});
		},
		changed(currentTags) {
			if (!Array.isArray(currentTags)) return;
			let resetTagsTo = [],
				errorTags = [];

			series()
				.each(currentTags, (tag, cb) => {
					if (!this.items.includes(tag)) {
						errorTags.push(tag);
						cb();
					} else {
						this.addTag(tag, (err) => {
							if (err) {
								errorTags.push(tag);
							} else {
								resetTagsTo.push(tag);
							}

							cb(err);
						});
					}
				})
				.next(cb => {
					let removedTags = this.shadowTags.filter(item => !currentTags.includes(item));
					series()
						.each(removedTags, (tag, cb) => {
							this.removeTag(tag, err => {
								if (err) {
									errorTags.push(tag);
									resetTagsTo.push(tag);
								}

								cb(err);
							});
						})
						.next(cb => {
							if (errorTags.length > 0) {
								this.errorState = true;
								this.errorMessage = 'Invalid tag' + (errorTags.length != 1 ? 's' : '') + ': ' + errorTags.join(', ');
							} else {
								this.errorState = false;
							}

							cb();
						})
						.end(cb)
				})
				.end(err => {
					if (err) {
						console.log(err);
						this.errorState = true;
						this.errorMessage = err;
					}
					this.chips = resetTagsTo;
					this.shadowTags = resetTagsTo;
				})
		}
	},
	created() {
		this.chips = this.tagged;
		this.shadowTags = this.tagged;
		this.getAvailableTags();
	}
}
</script>

<style scoped>
.detail-header-tags > div {
	margin-bottom: -50px;
}
.marbot {
	margin-bottom: 6px !important;
}
.tagErrorMessage {
	margin-top: 20px;
	padding: 0 0 40px 20px;
}
.v-chip {
	margin-left: 0px;
}
</style>